import { app } from '../../../../app';
import { Controller } from './sms-purchase-history.controller';

app.component('smsPurchaseHistory', {
    bindings: {purchaseHistory: '<'},
    controller: Controller,
    templateUrl: require('./sms-purchase-history.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/purchase-history/sms-purchase-history.component.js